import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import {
  findScheduleById,
  findScheduleStepsById,
} from 'Schedule/service/ScheduleService';
import ScheduleStep from 'Schedule/components/ScheduleStep';
import ScheduleNavigator from 'Schedule/components/ScheduleNavigator';

export default function ScheduleView(props, context) {
  const {
    params: {scheduleId},
  } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [scheduleSteps, setScheduleSteps] = useState([]);
  const [selectedStep, setSelectedStep] = useState({});
  const [schedule, setSchedule] = useState({});
  const handleRetrieveSchedule = async () => {
    if (scheduleId) {
      setSchedule(await findScheduleById(scheduleId));
    }
  };
  const slideChange = (event, newValue) => {
    if (selectedStep && selectedStep.sortOrder !== newValue) {
      setSelectedStep(scheduleSteps[newValue - 1]);
    }
  };
  const handleRetrieveScheduleSteps = async () => {
    if (scheduleId) {
      const tempStep = await findScheduleStepsById(scheduleId);

      setScheduleSteps(tempStep);
      setSelectedStep(tempStep[0]);
    }
  };
  const handleOnSelectStep = (step) => {
    setSelectedStep(step);
  };
  const handleOnClickChangeStep = (step, mod) => {
    if (step + mod >= 0 && step + mod < scheduleSteps.length) {
      setSelectedStep(scheduleSteps[step + mod]);
    }
  };

  useEffect(() => {
    const start = async () => {
      await handleRetrieveSchedule(scheduleId);
      await handleRetrieveScheduleSteps(scheduleId);
      setIsLoading(false);
    };

    if (scheduleId) start();
  }, [scheduleId]);

  return (
    !isLoading && (
      <>
        <ScheduleNavigator
          onClickChangeStep={handleOnClickChangeStep}
          slideChange={slideChange}
          selectedStepNumber={selectedStep && selectedStep.sortorder}
          schedule={schedule}
          scheduleSteps={scheduleSteps}
          onSelectStep={handleOnSelectStep}
        />
        {selectedStep && <ScheduleStep selectedStep={selectedStep} />}
      </>
    )
  );
}
ScheduleView.propTypes = {
  params: PropTypes.shape({
    scheduleId: PropTypes.string,
  }),
};
ScheduleView.contextTypes = {
  router: PropTypes.object.isRequired,
};
ScheduleView.defaultProps = {
  params: {scheduleId: null},
};
